import React, { FC, Fragment } from 'react';
import { Grid, TextField } from '@mui/material';
import { QuestionView, ResponseView } from '@views';
import { useNavigationEligibility } from '@components/SurveyDrawer/NavigationEligibilityContextProvider';

interface FreeTextResponseProps {
  currentQuestion: QuestionView;
}

export const FreeTextResponse: FC<FreeTextResponseProps> = ({ currentQuestion }) => {
  const [response, setResponse] = React.useState<string>('');
  const { triggerEligibility } = useNavigationEligibility();
  const handleFreeTextResponse = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    option: ResponseView
  ) => {
    if (!option.textResponse) option.textResponse = '';
    option.textResponse = e.target.value;
    setResponse(e.target.value);
    triggerEligibility();
  };

  return (
    <Fragment>
      {currentQuestion.responses.some((opt) => opt.responseType === 'FreeText') &&
        currentQuestion.responses.map((opt) => {
          if (opt.responseType === 'FreeText') {
            return (
              <Grid
                key={opt.id}
                size={{ xs: 12 }}
                flexWrap={'wrap'}
                alignContent="center"
                justifyContent={'flex-start'}
                display={'flex'}
                gap={2}
                paddingTop={2}
                paddingBottom={2}
              >
                <TextField
                  sx={{ minWidth: '100%' }}
                  onChange={(e) => handleFreeTextResponse(e, opt)}
                  label={opt.text}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
            );
          }
          return null;
        })}
    </Fragment>
  );
};
